import api from "../api/axios";

const prefix = "performance-bonus";

export const getPerformanceBonusByEmpId = async (employeeId, query) => {
  try {
    const response = await api.get(`${prefix}/employee/${employeeId}?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Employee performance bonus:", error);
    throw error;
  }
};

export const getEmployeesPerformanceBonus = async (company_id, query) => {
  try {
    const response = await api.get(
      `${prefix}/all-employees/${company_id}?${query}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Employees performance bonus:", error);
    throw error;
  }
};

export const createPerformanceBonus = async (data) => {
  try {
    const response = await api.post(`${prefix}/create`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating performance bonus:", error);
    throw error;
  }
};

export const getPerformanceBonusPercentage = async (employeeId, companyId) => {
  try {
    const response = await api.get(
      `${prefix}/percentage/${employeeId}/${companyId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching performance bonus percentage:", error);
    throw error;
  }
};

export const getNextEligibleMonth = async (employeeId) => {
  try {
    const response = await api.get(
      `${prefix}/next-eligible-month/${employeeId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching next eligible month:", error);
    throw error;
  }
};

export const getPerformanceBonusDeductions = async (employeeId, from, to) => {
  try {
    const response = await api.get(
      `${prefix}/deductions?employeeId=${employeeId}&from=${from}&to=${to}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching performance bonus deductions:", error);
    throw error;
  }
};

export const getPerformanceBonusReleaseDate = async (yearMonth, employeeId) => {
  try {
    const response = await api.get(
      `${prefix}/release-date/${yearMonth}/${employeeId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching performance bonus release date:", error);
    throw error;
  }
};
